
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`PropTypes`}</h1>
<p>{`Always use `}<inlineCode parentName="p">{`PropTypes`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ title }) => {
  return title;
};

// Good
const Component = ({ title }) => {
  return title;
};

Component.propTypes = {
  title: PropTypes.string.isRequired,
};
`}</code></pre>
<p>{`Always favor being specific when declaring `}<inlineCode parentName="p">{`PropTypes`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ user, title }) => {
  return \`\${title} \${user.name}\`;
};

Component.propTypes = {
  user: PropTypes.object,
  title: PropTypes.node,  // node would be ok, but we're using it clearly as a string
};

// Good
const Component = ({ user, title }) => {
  return \`\${title} \${user.name}\`;
};

Component.propTypes = {
  user: PropTypes.shape({ name: PropTypes.string }),
  title: PropTypes.string,
};
`}</code></pre>
<p>{`Ony declare `}<inlineCode parentName="p">{`PropTypes`}</inlineCode>{` for consumed props.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? That's another line of code to maintain and if the unused props are needed by the children components, the `}<inlineCode parentName="p">{`PropTypes`}</inlineCode>{` of those would warn.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ user }) => {
  return user.name;
};

Component.propTypes = {
  user: PropTypes.shape({ name: PropTypes.string, age: PropTypes.number }),,
};

// Good
const Component = ({ user }) => {
  return user.name;
};

Component.propTypes = {
  user: PropTypes.shape({ name: PropTypes.string }),
};
`}</code></pre>
<p>{`Never use `}<inlineCode parentName="p">{`PropTypes.array`}</inlineCode>{`. Use instead `}<inlineCode parentName="p">{`PropTypes.arrayOf`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? `}<inlineCode parentName="p">{`PropTypes.array`}</inlineCode>{` doesn't provide any useful information apart from it being an array.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ users }) => {
  // ... more code ...
};

Component.propTypes = {
  users: PropTypes.array,
};

// Good
const Component = ({ users }) => {
  // ... more code ...
};

Component.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string }))
};
`}</code></pre>
<p>{`Everytime `}<inlineCode parentName="p">{`PropTypes.oneOf`}</inlineCode>{` is used, your component must export an `}<em parentName="p">{`enum`}</em>{` with the possible values.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ category }) => {
  // ... more code ...
};

Component.propTypes = {
  category: PropTypes.oneOf([ 'primary', 'secondary' ]),
};

// Good
import Enum from 'Enum';


export const Category = Enum('PRIMARY', 'SECONDARY');


const Component = ({ category }) => {
  // ... more code ...
};

Component.propTypes = {
  category: PropTypes.oneOf(Object.values(Category)),
};
`}</code></pre>
<p>{`Always leave only one blank line between the component declaration and the `}<inlineCode parentName="p">{`PropTypes`}</inlineCode>{` declaration.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const Component = ({ category }) => {
  // ... more code ...
};


Component.propTypes = {
  category: PropTypes.oneOf([ 'primary', 'secondary' ]),
};

// Good
const Component = ({ category }) => {
  // ... more code ...
};

Component.propTypes = {
  category: PropTypes.oneOf([ 'primary', 'secondary' ]),
};
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;